<template>
  <div>
    NotFound Detail
  </div>
</template>

<script>
export default {
  name: 'GraphDetailNone'
}
</script>

<style scoped>

</style>
